import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/workprocess.css';
import {
  FaTruck, FaClipboardCheck, FaLock, FaCogs, FaRecycle, FaFileAlt, FaArrowRight
} from 'react-icons/fa';

const steps = [
  {
    num: '01',
    icon: <FaClipboardCheck />,
    title: 'Request & Assessment',
    desc: 'Contact us with details of your e-waste or metal scrap. We assess volume, type, and schedule a convenient pickup time.',
  },
  {
    num: '02',
    icon: <FaTruck />,
    title: 'Scheduled Pickup',
    desc: 'Our team arrives at your premises on the agreed date with all necessary equipment for safe, organized collection.',
  },
  {
    num: '03',
    icon: <FaLock />,
    title: 'Secure Transport',
    desc: 'All materials — especially data-bearing devices — are transported in sealed, tracked vehicles to our facility.',
  },
  {
    num: '04',
    icon: <FaCogs />,
    title: 'Sorting & Processing',
    desc: 'Items are sorted by type and condition. IT assets undergo certified data destruction before further processing.',
  },
  {
    num: '05',
    icon: <FaRecycle />,
    title: 'Eco-Friendly Recycling',
    desc: 'Sorted materials are processed using certified, environmentally responsible methods — zero unnecessary landfill.',
  },
  {
    num: '06',
    icon: <FaFileAlt />,
    title: 'Certification & Report',
    desc: 'You receive full documentation: destruction certificates, recycling reports, and compliance records for your records.',
  },
];

const WorkProcess = () => {
  const navigate = useNavigate();

  return (
    <section className="wp-section">
      <span className="wp-glow-a" />
      <span className="wp-glow-b" />

      <div className="container wp-inner">

        <header className="wp-head">
          <span className="wp-eyebrow">How It Works</span>
          <h2 className="wp-title">Our Work Process</h2>
          <p className="wp-desc">
            A simple, transparent six-step process — from your first call to the final
            recycling certificate. No guesswork, no hassle.
          </p>
        </header>

        <div className="wp-grid">
          {steps.map((s, i) => (
            <div className="wp-card" key={i} style={{ animationDelay: `${i * 80}ms` }}>
              <div className="wp-card-top">
                <span className="wp-num">{s.num}</span>
                <span className="wp-icon">{s.icon}</span>
              </div>
              <h3 className="wp-card-title">{s.title}</h3>
              <p className="wp-card-desc">{s.desc}</p>
              {i < steps.length - 1 && <span className="wp-arrow-right" aria-hidden="true" />}
            </div>
          ))}
        </div>

        <div className="wp-cta">
          <button className="wp-btn" onClick={() => navigate('/contact')}>
            Start the Process <FaArrowRight />
          </button>
        </div>

      </div>
    </section>
  );
};

export default WorkProcess;
